
import React from 'react';

interface MentoriasPageHeaderProps {
  totalMentorias: number;
  activeMentorias: number;
  inactiveMentorias: number;
}

export const MentoriasPageHeader: React.FC<MentoriasPageHeaderProps> = ({ 
  totalMentorias,
  activeMentorias,
  inactiveMentorias
}) => {
  return (
    <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-8">
      <div>
        <h1 className="text-3xl font-bold text-white mb-2">
          Gerenciar Mentorias
        </h1>
        <p className="text-gray-400">
          {totalMentorias} mentorias disponíveis ({activeMentorias} ativas, {inactiveMentorias} inativas).
        </p>
      </div>
    </div>
  );
};
